export default __webpack_public_path__ + "static/media/DataBase.1c8a58e6.svg";